import { createModel } from '@/store/tools';

const model = {
    namespace: 'paymanage',
    build: (T, A, S, R) => ({
        actiontypes: {
            'getStateList': T('getStateList'),
            'getTableSource': T('getTableSource'),
            'getDetail': T('getDetail'),
        },
        actions: {
            'getStateList': A('getStateList'),
            'getTableSource': A('getTableSource'),
            'getDetail': A('getDetail'),
        },
        sagas: {
            'getStateList': S('getStateList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getTableSource': S('getTableSource', '/?cmd=com.xqxc.api.pig.mis.pay.WithdrawalMisService.paymentApplication'),
            'getDetail': S('getDetail', '/?cmd=com.xqxc.api.pig.mis.pay.WithdrawalMisService.getPaymentApplication'),
        },
        reducers: {
            'stateList': R('getStateList', []),
            'tableSource': R('getTableSource', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'detail': R('getDetail', { auditLogs: [] }),
        }
    })
};
export default createModel(model);